import CamOfTheMoment from './CamOfTheMoment';

export default CamOfTheMoment;
